import { render, staticRenderFns } from "./DisableStaffDialog.vue?vue&type=template&id=1906742e&"
import script from "./DisableStaffDialog.vue?vue&type=script&lang=js&"
export * from "./DisableStaffDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports